import { GridColDef } from "@mui/x-data-grid";
import { TbGasStation } from "react-icons/tb";

import { TableHeader } from "@/components/TableHeader";
import { WeTrackVehicleData } from "@/types/wetrack.types";

export const DailyKm = (): GridColDef<WeTrackVehicleData["properties"]> => {
    return {
        field: "daily_km",
        headerName: "dailyKm",
        minWidth: 140,
        renderHeader: (params) => <TableHeader Component={TbGasStation} title={params.colDef.headerName!} />,
        renderCell: (params) => (
            <div className="flex p-1 items-center font-medium h-full gap-1  text-xs">
                {(Math.round((params.row.daily_km || 0) * 100) / 100).toFixed(2)}
            </div>
        ),
    };
};
